export const DEFAULT_SIGN_CODE = "DEFAULT_SIGN"
export const DEFAULT_SIGN_ICON = "assets/resources/DefaultSign.png"